import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-account-settinngs',
  templateUrl: './account-settinngs.component.html',
  styleUrls: ['./account-settinngs.component.scss']
})
export class AccountSettinngsComponent implements OnInit {

  products: Product[];
  items: MenuItem[];

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
        {label: 'Menu'},
        {label: 'Menu Active'},
      ];
}

}
